declare global {
  interface Window {
    config: any;
  }
}

// change with your own variables
type EnvType = {
  REACT_APP_VERSION: string;
  REACT_APP_AUTHORITY_URL: string;
  REACT_APP_OIDC_CLIENT: string;
  REACT_APP_OIDC_RESPONSE: string;
  REACT_APP_REDIRECT_URL: string;
  REACT_APP_USE_MOCK: string;
  REACT_APP_DASHBOARD_API_URL: string;
  REACT_APP_RECERT_URL: string;
  REACT_APP_QUALIFY_URL: string;
  REACT_APP_PDC_URL: string;
  REACT_APP_SHRM_ORG_SEARCH_URL: string;
  REACT_APP_SHRM_GLOBAL_URL: string;
  REACT_APP_SHRM_INDIA_URL: string;
  REACT_APP_SHRM_MENA_URL: string;
  REACT_APP_WORKPLACE_NEWS_URL: string;
  REACT_APP_SMARTSTREETS_COUNTRY: string;
  REACT_APP_LOGOUT_URL: string;
  REACT_APP_CERTIFICATE_PROMO_URL: string;
  REACT_APP_SHAREPOINT_BASE_URL: string;
  REACT_APP_ASK_AN_ADVISOR: string;
  REACT_APP_STORE_URL: string;
  REACT_APP_CONTACT_US_URL: string;
  REACT_APP_ABOUT_PAGE: string;
  REACT_APP_NEWSLETTER: string;
};
export const env: EnvType = { ...process.env, ...window.config };
